module.exports = __webpack_public_path__ + "img/help-icon.17ca2354.svg";